import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useWindowDimensions } from "@utilities";
import { HeaderComponent, HeaderNavigatorComponent } from "@components";
import { PATH_HOME } from "@routes";
import {
    AppDispatch,
    fetchCart,
    fetchCustomer,
    selectCart,
    useAppSelector,
    useIsLoggedIn,
} from "@redux";
import { useDispatch } from "react-redux";
import { fetchActiveDiscount } from "./Checkout";

export const HeaderModule = () => {
    // page hook
    const { width } = useWindowDimensions();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    // page states
    const [isScrollUp, setOnScrollUp] = useState<boolean>(window.scrollY > 50);
    const [isShowMenu, setIsShowMenu] = useState<boolean>(false);
    const isLoggedIn = useIsLoggedIn();
    // page redux
    useEffect(() => {
        if (isLoggedIn) {
            dispatch(fetchCart());
            dispatch(fetchCustomer());
            dispatch(fetchActiveDiscount());
        }
    }, [isLoggedIn]);

    const productCount = useAppSelector(selectCart).carts?.length;
    // page variable
    const pathName = location.pathname;
    const isHeader = pathName === PATH_HOME;
    const headerFix = pathName === PATH_HOME;
    // const isHeaderText = pathName === PATH_QUOTES || pathName === PATH_BOOKING;

    window.onscroll = () => {
        setOnScrollUp(window.scrollY > 50);
    };

    const handleBackToHome = () => {
        navigate(PATH_HOME);
    };

    const handleToggleShowMenu = () => {
        setIsShowMenu(!isShowMenu);
    };

    if (width >= 767 || isHeader) {
        return (
            <HeaderComponent
                $headerFix={headerFix}
                $isScrollUp={isScrollUp}
                $toggleShowMenu={handleToggleShowMenu}
                $isShowMenu={isShowMenu}
                $productCount={productCount}
            />
        );
    }

    // if (isHeaderText) {
    //     let headerTextTitle = "";
    //     if (pathName === PATH_QUOTES) {
    //         headerTextTitle = "Saved Quotes";
    //     } else if (pathName === PATH_BOOKING) {
    //         headerTextTitle = "My Booking";
    //     }
    //     return <StyledHeaderTitle>{headerTextTitle}</StyledHeaderTitle>;
    // }

    return (
        <HeaderNavigatorComponent
            $toggleShowMenu={handleToggleShowMenu}
            $isShowMenu={isShowMenu}
            $onBackToHome={handleBackToHome}
            $productCount={productCount}
        />
    );
};
